import apiService from 'services/apiService';

const baseUrl = `${window._env_.MONITOR_API_DOMAIN}`;

const getCompanyMonitorCheck = async (entityId: number, companyNumber: number) => {
  const url = `${baseUrl}/v1/entities/${entityId}/introducer/clients/${encodeURIComponent(
    companyNumber,
  )}/taken`;
  return await apiService.get(url);
};

export { getCompanyMonitorCheck };
